import { getDateObject } from "../../../helpers";

/**
 * Add last modified date object to photos
 * @param {array} photos
 */
export default function addLastModifiedDateObject(photos = []) {
  return photos.map(photo => {
    if (!!photo.lastModified) {
      photo.lastModifiedObj = getDateObject(photo.lastModified);
    } else {
      photo.lastModifiedObj = null;
    }

    return photo;
  });
}
